import { render, staticRenderFns } from "./BlockComponent.vue?vue&type=template&id=bea05cde"
import script from "./BlockComponent.vue?vue&type=script&lang=js"
export * from "./BlockComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports